import React, { useState, useEffect, useRef } from 'react';
import './SearchContainer.css'; // Asegurate de tener este CSS
import { AnimatePresence, motion } from 'framer-motion';
import { useForm } from 'react-hook-form';
import logger from '../../../../utils/logger';
import { CustomInputSearch } from './CustomInputSearch';
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";

export const SearchContainer = ({ handleObject, searchSchema, selectListOptions, defaultParam, paramDfValue }) => {
  const [isVisible, setIsVisible] = useState(false);

  logger.debug('searchSchema: ', searchSchema)
  logger.debug('selectListOptions: ', selectListOptions)

const hasDefaultValues = defaultParam !== undefined && paramDfValue !== undefined


  const { register, handleSubmit, reset, watch, formState: { isValid } } = useForm({

    mode: "onChange",
    // defaultValues: {
    //   // FormationPlaceId: "0", // 👈 siempre string
    // //  [defaultParam]: paramDfValue
    // }
    defaultValues: hasDefaultValues ? { [defaultParam]: paramDfValue } : {}
    
  })
const onSubmit = (data) => {
  logger.info('data: ', data)

  const newObjet = {
    ...data,
    PageSize: 10,
    PageIndex: 1,
  }

  handleObject(newObjet)
  // setIsVisible(false)
}

const onClean = (data) => {
  const emptyValues = Object.fromEntries(
    // Object.keys(data).map(key => [key, key === "FormationPlaceId" ? "0" : ""])
    Object.keys(data).map(key => [key, key === defaultParam ? paramDfValue : ""])
    
  );


  reset(emptyValues)

  const cleanObject = {
    ...emptyValues,
    PageSize: 10,
    PageIndex: 1,
  }

  handleObject(cleanObject)
}


const searchRef = useRef(null);

const toggleSearch = () => {
  setIsVisible(prev => !prev);
}


//? evento para cerrar el buscador al hacer click afuera de el

// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (searchRef.current && !searchRef.current.contains(event.target)) {
//       setIsVisible(false)
//     }
//   };

//   document.addEventListener('mousedown', handleClickOutside)

//   return () => {
//     document.removeEventListener('mousedown', handleClickOutside)
//   }
// }, [])



const [cleanEnable, setCleanEnable] = useState(false)
const allValues = watch()

useEffect(() => {
  const hasValues = Object.values(allValues).some(val => val !== "" && val !== paramDfValue)

  if (hasValues) {
    setCleanEnable(true)
  } else {
    setCleanEnable(false)
  }
}, [allValues])

return (
  <div className={`search  ${isVisible && 'searchMobileStyle'}`} ref={searchRef}>

    <div className="buttons-searchers-containers d-flex">

      {cleanEnable && isVisible === false &&

        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-top`}>Limpiar búsqueda</Tooltip>}
        >
          <button
            id="btnCleanAdvancedSearch"
            type='button'
            className="btn btn-link color-gray decoration-none d-flex align-items-center me-2 query-margin"
            onClick={handleSubmit(onClean)}
          >
            <span className="icon-trash">
              <i className="bi bi-trash3 outline trashClass"></i>
              <i className="bi bi-trash3-fill fill trashClass"></i>
            </span>

          </button>
        </OverlayTrigger>
      }

      <div className="btn-Asearch" >

        <div
          className='advanced-search-container d-flex p-2'
          onClick={toggleSearch}
        >
          <span>Búsqueda Avanzada</span>
          <span className={`material-symbols-outlined mI-arrow ${isVisible && 'arrow-subClass'}`}>keyboard_double_arrow_down</span>
        </div>

      </div>
    </div>




    <AnimatePresence>
      {isVisible && (

        <motion.div
          // className="container aSearch-container"
          className='w-100'
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          <form
            className="container aSearch-container"
            onSubmit={handleSubmit(onSubmit)}


          >


            {searchSchema && searchSchema.map((i) => {


              if (i.hasOwnProperty("select") && i.select === 'true') {
                return (selectListOptions && selectListOptions.length > 0 &&

                  <div className="form-floating form-aSearch" key={i.id}>

                    <select
                      {...register(i.name)}
                      id={i.name}
                      name={i.name}
                      className="form-select pt-0"
                    // defaultValue=""
                    >

                      <option value="0" disabled hidden></option>

                      {selectListOptions.map((option, index) => {

                        return <option key={index} value={option.id}> {option.name}</option>
                      })

                      }
                    </select>

                    <label className="label-fButtons" htmlFor={i.name}>{i.labelTitle}</label>
                  </div>
                )
              } else {
                return <CustomInputSearch
                  key={i.name}
                  register={register}
                  name={i.name}
                  type={i.type}
                  placeholder={i.labelTitle}
                />
              }
            })}





            {cleanEnable &&
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>Limpiar búsqueda</Tooltip>}
              >
                <button
                  id="btnCleanAdvancedSearch"
                  type='button'
                  className="btn btn-link color-gray decoration-none d-flex"
                  onClick={handleSubmit(onClean)}
                >
                  <span className="icon-trash">
                    <i className="bi bi-trash3 outline trashClass"></i>
                    <i className="bi bi-trash3-fill fill trashClass"></i>
                  </span>
                  {/* <span>Limpiar</span> */}
                </button>
              </OverlayTrigger>
            }


            <button
              type='submit'
              // disabled={!isValid}
              disabled={!cleanEnable}
              className="btn-Asearch2 btn btn-success"
              onClick={() => {
                // toggleSearch();
                setTimeout(() => {
                  // window.scrollTo({
                  //   top: document.body.scrollHeight,
                  //   behavior: 'smooth'
                  // })
                }, 500);


              }}
            >
              <span>Buscar</span>
            </button>

          </form>



        </motion.div>




      )}

    </AnimatePresence>


  </div >
);
};
